import { IAmbraDirectToViewerResponse } from '@nkr/store/donor';

interface IProps {
    donorId: number,
    donorAlias: string,
    hasCtScanOnline: boolean
    isAdminLogin: boolean,
    onOpenViewer: (donorId: number) => Promise<IAmbraDirectToViewerResponse>,
    onDeleteCtScanAmbra: (donorId: number) => void

}

const CtScan = (props: IProps) => {
    const handleOpenViewer = () => {
        props.onOpenViewer(props.donorId).then(response => {
            window.open(response.data.results, '_blank');
        });
    };

    const handleDeleteCtScanAmbra = () => {
        props.onDeleteCtScanAmbra;
    };

    const btnText = props.hasCtScanOnline == true ? 'Upload Additional Study' : 'Upload New CT Study';
    const url = "https://nkr.dicomgrid.com/api/v3/link/redirect?uuid=7a4a1869-d897-4d19-b2f9-0b439944f14b&email_address=integrationuser@nkr.com&supress_notification=1&integration_key=" + props.donorAlias + ':' + props.donorId;

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {props.hasCtScanOnline == true && (
                <>
                    <div style={{ marginRight: 10 }}>
                        <button type="button" className="btn" onClick={handleOpenViewer}>View Existing CT Study</button>
                    </div>
                    {props.isAdminLogin && (
                        <div style={{ marginRight: 10 }}>
                            <button type="button" className="btn" onClick={handleDeleteCtScanAmbra}>Delete Donor From Ambra</button>
                        </div>
                    )}
                </>
            )}
            <div>
                <a className="btn btn-primary" style={{ color: 'white' }} href={url} target='_blank'>{btnText}</a>
            </div>
        </div>
    );
}

export default CtScan;